import { render } from "./OnboardingGuide.vue?vue&type=template&id=6b579e76"
import script from "./OnboardingGuide.vue?vue&type=script&lang=js"
export * from "./OnboardingGuide.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__